<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				modal: {
					selector: 'modal-create-billing'
				},
				autocomplete: null,
				billing: {
					customer_id: null,
					name: null,
					identification_number: null,
					place: {
						formatted_address: null,
						name: null,
						google_place_id: null,
						url: null,
						country: null,
						country_short_name: null,
						postal_code: null,
						administrative_area_level_1: null,
						administrative_area_level_2: null,
						locality: null,
						route: null,
						street_number: null,
						sublocality_level_1: null,
						sublocality_level_2: null,
						lat: null,
						lng: null,
					},
				},
			}
		},
		methods: {
			open() {
				$('#input-autocomplete-create').val('')
				this.initAutocomplete()
				this.clearData()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			clearData() {
				this.billing.name = null
				this.billing.identification_number = null
				this.billing.email = null
				this.billing.phone = null
				this.billing.mobile = null
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteCreate),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					if(place) {
						that.loadPlace(place)
					}
				})
			},
			loadPlace(place) {
				var that = this
				for(var value in this.billing.place) {
					this.billing.place[value] = null
				}
				this.billing.place.formatted_address = place.formatted_address
				this.billing.place.name = place.name
				this.billing.place.google_place_id = place.place_id
				this.billing.place.url = place.url
				this.billing.place.lat = place.geometry.location.lat()
				this.billing.place.lng = place.geometry.location.lng()
				var address_components = []

				if(place.address_components) {
					place.address_components.forEach(function(element) {
						var type = element.types[0]
						var component = {
							type: type,
							value: element.long_name
						}
						address_components.push(component)
						if(type == 'country') {
							var component = {
								type: 'country_short_name',
								value: element.short_name
							}
							address_components.push(component)
						}
					})
				}
				
				address_components.forEach(function(element) {
					if(that.billing.place[element.type] !== 'undefined') {
						that.billing.place[element.type] = element.value
					}
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store() {
				var id = this.$route.params.id
				if(id) {
					var loading = Ladda.create(this.$refs.btnStore)
					loading.start()
					this.$http.post('admin/customers/' + id + '/add/billing', this.billing)
					.then(response => {
						loading.stop()
						this.$emit('reload')
						this.clearData()
						this.close()
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}).catch(function(response) {
						loading.stop()
						this.$emit('reload')
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning",
						})
					})
				}
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/billings/views/Create.vue